module.exports = __webpack_public_path__ + "static/media/educational_service_logo_mobile.9571293b.webp";